module.exports = __webpack_public_path__ + "img/seal2.1ee11ecd.png";